import { ReactElement } from 'react';
import { Redirect } from 'react-router-dom';
import { useCurrentUser } from '../Session';
import { UserType } from '../api';
import BasicLayout from '../layouts/BasicLayout';
import HomePage from '../pages/HomePage';

const HomeRoute = (): ReactElement => {
    const currentUser = useCurrentUser();

    switch (currentUser.type) {
        case UserType.SaleConsultant:
            return <Redirect to="/salesTransactions" />;

        case UserType.Dealer:
            return <Redirect to="/myBids" />;

        default:
            return (
                <BasicLayout onGrayBackground>
                    <HomePage />
                </BasicLayout>
            );
    }
};

export default HomeRoute;
